export default "__VITE_ASSET__Dn$E8YCy__"